var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo",class:_vm.computedClass},[_c('div',{staticClass:"sr-only"},[_vm._v("\n    Spartan Bioscience Inc.\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }